import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Spinner } from '@/Domain/components/Shared/Spinner';
import { useVerificationEmail } from '@/Domain/hooks/Auth/useVerificationEmail.hook';

const EmailVerificationPage = () => {
  const { t } = useTranslation(['email_verification', 'ERRORS']);

  const { handleResendClick, isPending, showResendMessage, apiError } = useVerificationEmail();

  return (
    <div className="text-center">
      <h1 className="font-semibold mb-8 text-xl text-center text-black">{t('title')}</h1>
      <p>{t('link.send')}</p>
      <Button
        variant="dark"
        className="w-full mt-5"
        onClick={handleResendClick}
        disabled={isPending}
      >
        {isPending ? <Spinner /> : t('button.resend')}
      </Button>
      {showResendMessage && <p className="mt-2 text-gray-950 text-base">{t('link.reset')}</p>}
      {apiError != null && <p className="mt-1 text-red-500 text-base">{t(`ERRORS:${apiError}`)}</p>}
    </div>
  );
};

export default EmailVerificationPage;
